const ROOT_API = '/api';

// login
export const POST_FINGERPRINT = `${ROOT_API}/nuxt/protect/fingermark`;
export const LOGIN = `${ROOT_API}/j_spring_security_check`;
//export const LOGIN_WECHAT = `${ROOT_API}/nuxt/register/callback`;
export const LOGIN_WECHAT = `${ROOT_API}/register/v2/wechat/login`;
export const LOGIN_WECHAT_NEW_USER_BIND = `${ROOT_API}/nuxt/register/bind/defaultemail`;
export const LOGIN_WECHAT_OLD_USER_BIND = `${ROOT_API}/nuxt/register/bind`;
export const LOGOUT = `${ROOT_API}/j_spring_security_logout`;
export const GET_USER_INFO = `${ROOT_API}/nuxt/web/student/info`;
export const GET_TUTOR_INFO = `${ROOT_API}/nuxt/student/tutorinfo`;
export const CHECK_CAPTCHA = `${ROOT_API}/nuxt/public/slidercaptcha`;
export const GET_USER = `${ROOT_API}/register/v2/students/info`;
export const CAPTCHA = `${ROOT_API}/captcha`;
export const LOGIN_SMS_REGISTER_WITHOUT_MOBILE = `${ROOT_API}/sms/register/v2/global`;
export const LOGIN_SMS_REGISTER = `${LOGIN_SMS_REGISTER_WITHOUT_MOBILE}/`;
export const LOGIN_SMS_REGISTER_UNIQUE_GLOBAL = `${ROOT_API}/sms/register/unique/global/`;
export const LOGIN_MOBILE_SMS = `${ROOT_API}/register/v2/sms`;
export const LOGIN_MOBILE_PASSWD = `${ROOT_API}/register/v2/loginByMobile`;
export const LOGIN_BIND_MOBILE = `${ROOT_API}/register/v2/bindmobile`;
export const CHECK_EXIST_MOBILE = `${ROOT_API}/register/v2/checkexist/`;
export const LOGIN_SMS_PASSWD_INIT = `${ROOT_API}/register/v2/sms/password/init`;
export const LOGIN_SMS_REGISTER_MOBILE_PRECHECK = `${ROOT_API}/register/v2/mobile/precheck`;
export const LOGIN_SMS_REGISTER_WECHAT_PRECHECK = `${ROOT_API}/register/v2/wechat/precheck`;
export const CHECK_EXIST_NICKNAME = `${ROOT_API}/register/v2/checknickname`;
export const LOGIN_SMS_REGISTER_NEW_USER = `${ROOT_API}/register/v2/newuser`;
export const GET_WECHAT_QRCODE = `${ROOT_API}/nuxt/register/login/qrcode`;
export const CHECK_LOGIN_QRCODE = `${ROOT_API}/nuxt/register/checkqrcode/`;
export const CHECK_BIND_QRCODE = `${ROOT_API}/nuxt/register/checkbindqrcode/`;
export const SAVE_VENDOR_ID = `${ROOT_API}/nuxt/register/vendor/save`;
export const EVENT_TRACKER = `${ROOT_API}/nuxt/tracking/www/access`;
export const GET_VISITOR_ID = `${ROOT_API}/nuxt/tracking/guid`;

// free course
export const GET_ALL_COURSES = `${ROOT_API}/nuxt/public/freecourses`;

// dashboard
export const GET_DASHBOARD = `${ROOT_API}/nuxt/web/tree/mycourses`;
export const POST_PUT_OFF = `${ROOT_API}/nuxt/defer/choose`;
export const POST_PRE_OPEN = `${ROOT_API}/nuxt/defer/preopen`;
export const POST_OPEN_UP_COURSE = `${ROOT_API}/nuxt/yz/opencpa`;

// course
export const GET_COURSE = `${ROOT_API}/nuxt/web/tree/course/`;
export const GET_MINI_COURSE = `${ROOT_API}/nuxt/web/tree/optionalcourse`;
export const GET_FREE_COURSE = `${ROOT_API}/nuxt/web/tree/freecourse`;
export const GET_PURE_COURSE = `${ROOT_API}/nuxt/web/tree/coursevideo`;
export const GET_LIVE_COURSE = `${ROOT_API}/nuxt/web/tree/course/live`;
export const GET_LIVE_TOKEN = `${ROOT_API}/nuxt/polyv/live/token`;
export const GET_TRAIL_COURSE = `${ROOT_API}/nuxt/public/trailcourse`;
export const GET_COURSE_CLASS_INFO = `${ROOT_API}/nuxt/class/info/`;
export const getCourseTaskInfo = ({ courseId }) => `${ROOT_API}/nuxt/web/tree/taskinfo/${courseId}`;
export const getPersonalTaskInfo = ({ courseId }) =>
  `${ROOT_API}/nuxt/web/tree/personaltask/${courseId}`;
export const getCourseTaskStatus = ({ courseId }) =>
  `${ROOT_API}/nuxt/web/tree/taskstatus/${courseId}`;
export const getCourseMultiTaskStatus = ({ courseId }) =>
  `${ROOT_API}/nuxt/web/tree/multitaskstatus/${courseId}`;
export const getCourseMyTaskStatus = ({ courseId }) =>
  `${ROOT_API}/nuxt/web/tree/mytaskstatus/${courseId}`;
export const checkAndAddCourseTask = ({ courseId }) =>
  `${ROOT_API}/nuxt/xly/checkandadd/${courseId}`;
export const addByClassidCourseTask = ({ courseId }) =>
  `${ROOT_API}/nuxt/xly/addbyclassid/${courseId}`;

export const getClassRestriction = ({ courseId }) =>
  `${ROOT_API}/nuxt/class/restriction/${courseId}`;
export const getClassRestrictionWebTreePath = ({ fileId }) =>
  `${ROOT_API}/nuxt/web/tree/path/${fileId}`;

// book
export const GET_BOOK = `${ROOT_API}/nuxt/web/tree/book/`;
export const GET_MINI_BOOK = `${ROOT_API}/nuxt/web/tree/minibook/`;
export const GET_FREE_BOOK = `${ROOT_API}/nuxt/web/tree/freebook/`;
export const GET_TRAIL_BOOK = `${ROOT_API}/nuxt/public/trailbook/`;

// user center
export const PASSWORD_FORGET = `${ROOT_API}/nuxt/register/password/forget`;
export const PASSWORD_RESET_VALID = `${ROOT_API}/nuxt/register/password/reset/valid`;
export const PASSWORD_RESET_RESET_WITH_TOKEN = `${ROOT_API}/nuxt/register/password/resetwithtoken`;
export const POST_UPDATE_PROFILE = `${ROOT_API}/nuxt/student/profile/update`;
export const UPDATE_NICKNAME_GENDER = `${ROOT_API}/nuxt/student/updatenickname`;
export const UPDATE_AVATAR = `${ROOT_API}/nuxt/student/updateavatar`;
export const UPDATE_PASSWORD = `${ROOT_API}/nuxt/student/password/reset`;
export const CHECK_MOBILE = `${ROOT_API}/nuxt/register/check/smscode`;
export const EDIT_PASSWORD = `${ROOT_API}/nuxt/register/password/edit`;
export const BIND_EMAIL = `${ROOT_API}/nuxt/student/email/update`;
export const BIND_WECHAT = `${ROOT_API}/nuxt/register/bind/callback`;
export const UPDATE_MOBILE = `${ROOT_API}/nuxt/student/mobile/update`;
export const UPDATE_WECHAT = `${ROOT_API}/nuxt/web/student/updatewechatno`;
export const UNBIND_WECHAT = `${ROOT_API}/nuxt/register/removewechat`;
export const NEED_ID_CHECK = `${ROOT_API}/nuxt/student/needidcheck/`;
export const PASSPORT_SUBMIT = `${ROOT_API}/nuxt/student/passportsubmit`;
export const ID_CHECK_AND_SAVE = `${ROOT_API}/nuxt/student/idcheckandsave`;
export const IDENTIFICATION_CONFIG = `${ROOT_API}/nuxt/protect/identificationconfig`;
export const ID_REFUSE = `${ROOT_API}/nuxt/student/idrefuse`;
export const ID_RECALL = `${ROOT_API}/nuxt/student/idrecall`;
export const makeEsgSurveyNew = () => `${ROOT_API}/nuxt/survey/esg/new`;
export const makeSurveyNew = () => `${ROOT_API}/nuxt/survey/submit`;

export const checkSurveyHasposted = ({ surveyId }) =>
  `${ROOT_API}/nuxt/survey/hasposted/${surveyId}`;
export const getSurvey = ({ surveyId }) => `${ROOT_API}/nuxt/survey/${surveyId}`;

export const getReopenInfo = () => `${ROOT_API}/nuxt/student/reopeninfo`;
export const reopenSubmit = () => `${ROOT_API}/nuxt/student/reopen/submit`;

// important message
export const GET_IMPORTANT_MESSAGE = `${ROOT_API}/nuxt/web/message/unread/important`;
export const READ_IMPORTANT_MESSAGE = `${ROOT_API}/nuxt/web/message/important/read`;
export const ACTION_IMPORTANT_MESSAGE = `${ROOT_API}/nuxt/web/message/important/action`;

// tracking vendor record
export const TRACKING_VENDOR_RECORD = `${ROOT_API}/nuxt/tracking/record/access`;

// question
export const POST_AUTO_REMOVE = `${ROOT_API}/nuxt/web/question/autoremove`;

// Q and A
export const GET_QA_QUESTION_TAGS = `${ROOT_API}/web/v4/public/qa/tags`;
export const getPublicQaQuestionList = ({ qType, courseTagId, bookTagId, pageNo, pageSize }) =>
  `${ROOT_API}/web/v4/public/qa/question/list/${qType}/${courseTagId}/${bookTagId}/${pageNo}/${pageSize}`;
export const getQaQuestionList = ({ qType, courseTagId, bookTagId, pageNo, pageSize }) =>
  `${ROOT_API}/web/v4/qa/question/list/${qType}/${courseTagId}/${bookTagId}/${pageNo}/${pageSize}`;
export const GET_QA_SEARCH_LIST = `${ROOT_API}/web/v3/public/qa/search`;
export const getQaQuestion = ({ questionId }) =>
  `${ROOT_API}/nuxt/public/qa/question/${questionId}`;
export const QA_QUESTION_DO_THUMB = `${ROOT_API}/web/v2/qa/thumb`;
export const QA_QUESTION_TO_FOLLOW = `${ROOT_API}/web/v4/qa/follow/confirm`;
export const QA_QUESTION_TO_UNFOLLOW = `${ROOT_API}/web/v4/qa/follow/cancel`;
export const QA_QUESTION_ANSWER_COMMENT = `${ROOT_API}/web/v2/qa/answer/comment`;
export const QA_QUESTION_ANSWER_ACCEPT = `${ROOT_API}/web/v2/qa/answer/accept`;
export const QA_QUESTION_ANSWER_FEEDBACK = `${ROOT_API}/web/v4/qa/feedback/new`;
export const QA_QUESTION_ANSWER_NEW = `${ROOT_API}/web/v2/qa/answer/new`;
export const QA_QUESTION_OSS_POLICY = `${ROOT_API}/web/v3/oss/policy`;
export const GET_QA_QUESTION_ASK_TAGS = `${ROOT_API}/nuxt/qa/tags`;
export const QA_QUESTION_QUESTION_NEW = `${ROOT_API}/web/v2/qa/question/new`;
export const QA_QUESTION_BULLET_NEW = `${ROOT_API}/nuxt/qa/bullet/new`;
export const GET_QA_CPA_INFO = `${ROOT_API}/nuxt/qa/cpainfo`;
export const QA_QUESTION_TO_UNREAD = `${ROOT_API}/nuxt/qa/question/markunread`;
export const getQuestionReferralInQuestion = ({ questionId }) =>
  `${ROOT_API}/nuxt/qa/question/list/referal/qa/${questionId}`;
export const getQuestionSharedNoteInQuestion = ({ questionId }) =>
  `${ROOT_API}/nuxt/qa/question/list/share/${questionId}`;
export const POST_QA_GRADE = `${ROOT_API}/nuxt/qa/grade`;
export const getQaBulletTags = ({ courseId, bulletId }) =>
  `${ROOT_API}/nuxt/qa/bullettags/${courseId}/${bulletId}`;
export const getQaBulletListReferal = ({ bulletId }) =>
  `${ROOT_API}/nuxt/qa/bullet/list/referal/${bulletId}`;

// mall
export const GET_MALL_CATEGORY_GOOD_LIST = `${ROOT_API}/web/v3/public/goods/list/`;
export const GET_MALL_GOOD_DETAIL = `${ROOT_API}/web/v3/public/goods/detail/`;
export const getMallPublicGoodQrcode = ({ goodId }) =>
  `${ROOT_API}/nuxt/public/goods/code/${goodId}`;
export const MALL_ADD_FOR_TAOBAO = `${ROOT_API}/nuxt/yz/open/course/code`;
export const GET_MALL_GOOD_QRCODE = `${ROOT_API}/nuxt/yz/qrcode/goods/`;
export const CHECK_MALL_GOOD_QRCODE = `${ROOT_API}/nuxt/yz/qrcode/ref/check`;
export const MALL_ADD_FOR_FREE = `${ROOT_API}/nuxt/yz/course/add`;
export const MAKE_MALL_YZ_QRCODE = `${ROOT_API}/nuxt/yz/qrcode/new`;
export const makeMallWechatQrcode = () => `${ROOT_API}/nuxt/yz/qrcode/wechat/new`;
export const CHECK_MALL_SCAN_QRCODE = `${ROOT_API}/nuxt/yz/qrcode/check/`;
export const CHECK_BUTTON_MALL_SCAN_QRCODE = `${ROOT_API}/nuxt/yz/qrcode/checkbutton/`;
export const MAKE_MALL_PAYPAL_URL = `${ROOT_API}/nuxt/paypal/new`;
export const GET_MALL_PAYPAL_INFO = `${ROOT_API}/nuxt/paypal/return/`;
export const GET_MALL_PAYPAL_RESULT = `${ROOT_API}/nuxt/paypal/confirm/`;
//export const GET_WEB_ALIPAY_PAGE_SNAPLET = `${ROOT_API}/nuxt/web/alipay/page/snaplet`;
//export const GET_WEB_ALIPAY_WAP_SNAPLET = `${ROOT_API}/nuxt/web/alipay/wap/snaplet`;
export const MAKE_MALL_ALIPAY_HTML = `${ROOT_API}/nuxt/web/alipay/new`;
export const makeMallAlipaySnapletTradeHtml = ({ tradeId }) =>
  `${ROOT_API}/nuxt/web/alipay/snaplet/${tradeId}`;
//export const GET_MALL_ALIPAY_NOTIFICATION = `${ROOT_API}/nuxt/web/alipay/notification`;
export const MAKE_MALL_HAIER_URL = `${ROOT_API}/nuxt/haier/new`;
export const makeMallHaierLoanTradeUrl = ({ tradeId }) =>
  `${ROOT_API}/nuxt/haier/loan/${tradeId}`;
export const getMallNormalTradeDetail = ({ tradeId }) =>
  `${ROOT_API}/nuxt/activity/common/detail/${tradeId}`;
export const getMallLockpriceDepositTradeDetail = ({ tradeId }) =>
  `${ROOT_API}/nuxt/activity/deposit/detail/${tradeId}`;
export const getMallPresellDepositTradeDetail = getMallLockpriceDepositTradeDetail;
export const getMallLockpriceBalanceTradeDetail = ({ tradeId }) =>
  `${ROOT_API}/nuxt/activity/lockprice/balance/detail/${tradeId}`;
export const getMallPresellBalanceTradeDetail = ({ tradeId }) =>
  `${ROOT_API}/nuxt/activity/presell/balance/detail/${tradeId}`;
export const makeMallNormalTradeQrcode = ({ tradeId }) =>
  `${ROOT_API}/nuxt/activity/common/qrcode/${tradeId}`;
export const makeMallLockpriceDepositTradeQrcode = ({ tradeId }) =>
  `${ROOT_API}/nuxt/activity/deposit/qrcode/${tradeId}`;
export const makeMallPresellDepositTradeQrcode = makeMallLockpriceDepositTradeQrcode;
export const makeMallLockpriceBalanceTradeQrcode = ({ tradeId }) =>
  `${ROOT_API}/nuxt/activity/lockprice/balance/qrcode/${tradeId}`;
export const makeMallNormalTradeWechatQrcode = ({ tradeId }) =>
  `${ROOT_API}/nuxt/activity/common/wechat/${tradeId}`;
export const makeMallLockpriceDepositTradeWechatQrcode = ({ tradeId }) =>
  `${ROOT_API}/nuxt/activity/deposit/wechat/${tradeId}`;
export const makeMallPresellDepositTradeWechatQrcode = makeMallLockpriceDepositTradeWechatQrcode;
export const makeMallLockpriceBalanceTradeWechatQrcode = ({ tradeId }) =>
  `${ROOT_API}/nuxt/activity/lockprice/balance/wechat/${tradeId}`;
export const makeMallNormalTradePaypal = ({ tradeId }) =>
  `${ROOT_API}/nuxt/activity/common/paypal/${tradeId}`;
export const makeMallLockpriceDepositTradePaypal = ({ tradeId }) =>
  `${ROOT_API}/nuxt/activity/deposit/paypal/${tradeId}`;
export const makeMallPresellDepositTradePaypal = makeMallLockpriceDepositTradePaypal;
export const makeMallLockpriceBalanceTradePaypal = ({ tradeId }) =>
  `${ROOT_API}/nuxt/activity/lockprice/balance/paypal/${tradeId}`;
export const GET_MARKET_TRADE_LIST = `${ROOT_API}/market/trade/list`;
export const GET_MARKET_TRADE_DETAIL = `${ROOT_API}/market/trade/detail`;
export const GET_MALL_COUNTRIES = `${ROOT_API}/register/v2/countries`;
export const MALL_SMS_REGISTER = `${ROOT_API}/sms/register/global/`;
export const mallSmsRegisterV2 = ({ mobile }) => `${ROOT_API}/sms/register/v2/global/${mobile}`;
export const VALIDATE_EMAIL = `${ROOT_API}/validate/email`;
export const PREPURCHAGE_FROM_WECHAT = `${ROOT_API}/nuxt/student/prepurchase`;
export const PREPURCHAGE_FROM_EMAIL = `${ROOT_API}/nuxt/yz/wechat/save`;
export const GET_MALL_FREE_VIDEO = `${ROOT_API}/nuxt/public/freeinmall/`;
export const GET_MALL_CPA_FREE_VIDEO = `${ROOT_API}/nuxt/public/freeinmall/cpa`;
export const GET_MALL_COUPON_LIST = `${ROOT_API}/nuxt/yz/couponlist/`;
export const getMallTradeCouponList = ({ tradeId }) =>
  `${ROOT_API}/nuxt/yz/trade/couponlist/${tradeId}`;
export const POST_ACHIEVEMENTS_BENEFIT = `${ROOT_API}/web/v3/exam/bird/benefit`;
export const POST_ACHIEVEMENTS_CHECK = `${ROOT_API}/web/v3/exam/check`;
export const SMS_REGISTER = `${ROOT_API}/nuxt/sms/register/global/`;
export const GET_YZ_REFS = `${ROOT_API}/nuxt/yz/refs`;
export const CHOOSE_YZ_REFS = `${ROOT_API}/nuxt/yz/ref/choose`;
export const GET_MY_POINTS = `${ROOT_API}/nuxt/mbpoints/mypoints`;
export const GET_POINTS_GOODS_LIST = `${ROOT_API}/nuxt/mbpoints/goodslist`;
export const MAKE_POINTS_YZ_QRCODE = `${ROOT_API}/nuxt/mbpoints/qrcode/new`;
export const GET_POINTS_YZ_STATUS = `${ROOT_API}/nuxt/mbpoints/qrcode/check/`;
export const MAKE_POINTS_PAYPAL_URL = MAKE_MALL_PAYPAL_URL;
export const GET_POINTS_PAYPAL_INFO = `${ROOT_API}/nuxt/mbpoints/return/`;
export const GET_POINTS_PAYPAL_RESULT = `${ROOT_API}/nuxt/mbpoints/confirm/`;
export const GET_FAVORITE = `${ROOT_API}/nuxt/videos/collectdetail`;
export const GET_BOOKMARK_TREE = `${ROOT_API}/nuxt/videos/allcollection/coursebooktree`;
export const GET_BOOKMARK = `${ROOT_API}/nuxt/videos/allcollection`;
export const GET_RANKING_LIST = `${ROOT_API}/nuxt/ranking/list/`;
export const GET_RANKING_DETAIL = `${ROOT_API}/nuxt/ranking/`;
export const GET_PZ_MOCK_PAPER_RESULT = `${ROOT_API}/web/v3/pzmock/paper/result/`;
export const GET_DIAGNOSIS_INFO = `${ROOT_API}/nuxt/diagnosis/`;
export const GET_STUDENT_ADDRESS = `${ROOT_API}/nuxt/web/student/addresses`;
export const MAKE_NEW_ADDRESS = `${ROOT_API}/nuxt/yz/address/new`;
export const DELETE_ADDRESS = `${ROOT_API}/nuxt/yz/address/delete`;

// Reader Center
export const GET_READER_CENTER_LIST = `${ROOT_API}/web/v3/readercenter/list`;
export const GET_READER_GENERATE_PDF = `${ROOT_API}/pdf/v2/generate/`;
export const GET_READER_GENERATE_IDENTIFY = `${ROOT_API}/web/v3/readercenter/identify`;
export const GET_READER_GENERATE_QUESTIONS = `${ROOT_API}/web/v3/readercenter/questions/`;
export const GET_READER_CENTER_QUESTION_LIST = `${ROOT_API}/nuxt/readercenter/commonlist`;
export const GET_READER_CENTER_PZ_FILTER_DATA = `${ROOT_API}/nuxt/readercenter/filterdata`;
export const POST_READER_CENTER_QUESTION_ANSWER = `${ROOT_API}/nuxt/readercenter/answer`;
export const GET_READER_CENTER_FREE_BOOK = `${ROOT_API}/nuxt/readercenter/book/`;

// notes
export const GET_NOTES_LIST = `${ROOT_API}/nuxt/notes/courses/list`;
export const GET_NOTES_BOOKS_LIST = `${ROOT_API}/nuxt/notes/books/list`;
export const GET_NOTES_DETAIL = `${ROOT_API}/nuxt/notes/list/`;
export const UPDATE_BULLET_NOTE = `${ROOT_API}/nuxt/notes/bullet/save`;
export const UPDATE_QUESTION_NOTE = `${ROOT_API}/nuxt/notes/question/save`;
export const FETCH_BULLET_NOTE = `${ROOT_API}/nuxt/notes/bullet`;
export const FETCH_QUESTION_NOTE = `${ROOT_API}/nuxt/notes/question`;
export const DOWNLOAD_NOTE = `${ROOT_API}/nuxt/notes/pdf/gen/`;
export const DOWNLOAD_NOTE_IN_DETAIL = DOWNLOAD_NOTE;
export const PUBLIC_NOTES_RFT = `${ROOT_API}/nuxt/public/notes/rft`;
export const DOWNLOAD_NOTE_RFT = `${ROOT_API}/nuxt/notes/rft/pdf/`;
export const NOTE_OSS_POLICY = `${ROOT_API}/nuxt/oss/notespolicy`;

// message
export const GET_MESSAGES = `${ROOT_API}/nuxt/web/message/`;
export const READ_MESSAGE = `${ROOT_API}/nuxt/web/message/read`;
export const READ_ALL_MESSAGE = `${ROOT_API}/nuxt/web/message/readall`;
export const GET_REGION_NO = `${ROOT_API}/nuxt/register/countries`;
export const CERTIFICATE = `${ROOT_API}/nuxt/student/certificate`;

// video
export const VIDEO_START = `${ROOT_API}/nuxt/videos/start`;
export const VIDEO_PAUSE = `${ROOT_API}/nuxt/videos/pause`;
export const VIDEO_STOP = `${ROOT_API}/nuxt/videos/stop`;
export const POST_VIDEOS_COLLECT = `${ROOT_API}/nuxt/videos/collect`;
export const GET_VIDEO_TOKEN = `${ROOT_API}/nuxt/polyv/token`;
export const GET_PUBLIC_KEY = `${ROOT_API}/nuxt/polyv/genPublicKey`;
export const VIDEO_CHANGE_SPEED = `${ROOT_API}/nuxt/student/defaultspeed`;
export const POST_LAST_PROGRESS = `${ROOT_API}/nuxt/videos/lastprogress`;
export const MARQUEE_QUICK_CHECK = `${ROOT_API}/nuxt/polyv/quickcheck`;

// Bullet
export const BULLET_START = `${ROOT_API}/nuxt/bullets/study`;
export const BULLET_FINISH = `${ROOT_API}/nuxt/bullets/finish`;

// Exercise
export const GET_QUESTION_LIST = `${ROOT_API}/nuxt/web/question/commonlist`;
export const getQuestionListType = ({ type }) => `${ROOT_API}/nuxt/web/question/commonlist/${type}`;
export const GET_FIRST_QUESTION = `${ROOT_API}/nuxt/web/question`;
export const POST_QUESTION_ANSWER = `${ROOT_API}/nuxt/web/question/answer`;
export const POST_CHALLENGE_QUESTION_ANSWER = `${ROOT_API}/nuxt/web/question/challengeanswer`;
export const GET_WRONG_QUESTION_LIST = `${ROOT_API}/nuxt/web/question/mywronglist`;
export const GET_COLLECTION_QUESTION_LIST = `${ROOT_API}/nuxt/web/question/mycollection`;
export const GET_TYPE_QUESTION_LIST = `${ROOT_API}/nuxt/web/question/typelist`;
export const GET_BOOK_TREE_QUESTION_LIST = `${ROOT_API}/nuxt/web/question/booktreelist`;
export const GET_PZ_FILTER_DATA = `${ROOT_API}/nuxt/web/question/filterdata`;
export const getPzFilterDataType = ({ courseId, type }) =>
  `${ROOT_API}/nuxt/web/question/filterdata/${courseId}/${type}`;
export const POST_QUESTION_COLLECT = `${ROOT_API}/nuxt/web/question/mark`;
export const GET_COURSE_ANALYSIS = `${ROOT_API}/nuxt/web/question/courseanalysis`;
export const GET_AFTER_EXERCISE = `${ROOT_API}/nuxt/web/question/commonlist/after`;
export const GET_QUESTION_REFERRAL_LIST = `${ROOT_API}/nuxt/qa/question/list/referal`;
export const POST_QUESTION_QA = `${ROOT_API}/nuxt/qa/question/new`;
export const POST_REMOVE_WRONG_LIST = `${ROOT_API}/nuxt/web/question/removewronglist`;

// practice
export const GET_BEFORE_PRACTICE = `${ROOT_API}/nuxt/web/question/subject/before`;
export const GET_PRACTICE = `${ROOT_API}/nuxt/web/question/subject`;
export const GET_AFTER_PRACTICE = `${ROOT_API}/nuxt/web/question/subject/after`;
export const POST_QUESTION_REPORT = `${ROOT_API}/nuxt/web/question/report`;

// challenge
export const GET_BEFORE_CHALLENGE = `${ROOT_API}/nuxt/web/question/challenge/before`;
export const GET_CHALLENGE = `${ROOT_API}/nuxt/web/question/challenge`;
export const GET_AFTER_CHALLENGE = `${ROOT_API}/nuxt/web/question/challenge/after`;
export const TS_CHALLENGE = `${ROOT_API}/nuxt/web/question/challenge/save`;

// Mock
export const GET_BEFORE_MOCK_DATA = `${ROOT_API}/nuxt/web/pzmock/paperInfo`;
export const getRedoBeforeMock = ({ paperId }) =>
  `${ROOT_API}/nuxt/web/pzmock/redopaper/${paperId}`;
export const GET_EVENTS = `${ROOT_API}/nuxt/web/pzmock/paperlist`;
export const GET_MOCK_DATA = `${ROOT_API}/nuxt/web/pzmock/paper`;
export const POST_MOCK_SUBMIT = `${ROOT_API}/nuxt/web/pzmock/paper/submit`;
export const GET_MOCK_QUESTION = `${ROOT_API}/nuxt/web/pzmock/question`;
export const POST_MOCK_QUESTION_ANSWER = `${ROOT_API}/nuxt/web/pzmock/question/answer`;
export const GET_MOCK_RANKING = `${ROOT_API}/nuxt/web/pzmock/paper/ranking/`;
export const GET_MOCK_RESULT = `${ROOT_API}/nuxt/web/pzmock/paper/result/`;
export const POST_MOCK_VOICE_FINISH = `${ROOT_API}/nuxt/web/pzmock/paper/voice/finish`;
export const POST_MOCK_VOICE_PAUSE = `${ROOT_API}/nuxt/web/pzmock/paper/voice/pause`;

export const getClassChineseFrm = ({ courseId, bookId }) =>
  `${ROOT_API}/nuxt/class/chinesefrm/${courseId}/${bookId}`;
export const postClassChineseFrmConfirm = () =>
  `${ROOT_API}/nuxt/class/chinesefrm/confirm`;

// file download
export const GET_GENERATE_FILE = `${ROOT_API}/nuxt/pdf/generate`;
export const GET_GENERATE_BOOK_ALL_FILE = `${ROOT_API}/nuxt/pdf/zip-all-pdf`;

// coupons
export const GET_MY_COUPONS = `${ROOT_API}/nuxt/student/mycoupons`;

// flash card
export const GET_COURSE_FLASH_CARD_LIST = `${ROOT_API}/nuxt/card/cardlist`;
export const GET_BOOK_FLASH_CARD_INFO = `${ROOT_API}/nuxt/card/bookcardinfo`;
export const GET_BOOK_FLASH_CARD_FILTER = `${ROOT_API}/nuxt/card/filter`;
export const SEQUENCE_BOOK_FLASH_CARD_LIST = `${ROOT_API}/nuxt/card/sequence`;
export const RANDOM_BOOK_FLASH_CARD_LIST = `${ROOT_API}/nuxt/card/random`;
export const GET_REVISE_BOOK_FLASH_CARD_LIST = `${ROOT_API}/nuxt/card/revise`;
export const GET_FAVORITE_BOOK_FLASH_CARD_LIST = `${ROOT_API}/nuxt/card/favorite/list`;
export const GET_FAVORITE_COURSE_FLASH_CARD_LIST = `${ROOT_API}/nuxt/card/course/favorite/list`;
export const GET_FLASH_CARD_DETAIL = `${ROOT_API}/nuxt/card/detail`;
export const ANSWER_FLASH_CARD = `${ROOT_API}/nuxt/card/answercard`;
export const TOGGLE_FAVORITE_FLASH_CARD = `${ROOT_API}/nuxt/card/favorite`;
export const TOGGLE_FLASH_CARD_ADD_QUESTION_SEQUENCE = `${ROOT_API}/nuxt/card/sequence/addquestion`;
export const TOGGLE_FLASH_CARD_ADD_QUESTION_RANDOM = `${ROOT_API}/nuxt/card/random/addquestion`;
export const POST_FLASH_CARD_REPORT = `${ROOT_API}/nuxt/card/report`;

// homework
export const getStudentworkpolicy = () => `${ROOT_API}/nuxt/oss/studentworkpolicy`;
export const getStudentworkList = ({ bookId }) =>
  `${ROOT_API}/nuxt/web/tree/studentwork/list/${bookId}`;
export const newStudentwork = () => `${ROOT_API}/nuxt/web/tree/studentwork/new`;
export const getStudentwork = () => `${ROOT_API}/nuxt/web/tree/studentwork/get`;
export const deleteStudentwork = () => `${ROOT_API}/nuxt/web/tree/studentwork/delete`;

// IM token
export const GET_IM_TOKEN = `${ROOT_API}/nuxt/chat/token`;
export const GET_IM_TEAM_ANNOUNCEMENT = `${ROOT_API}/nuxt/chat/announcement`;

export const getAlumniRefresh = () => `${ROOT_API}/nuxt/alumni/refresh`;
export const makeAlumniBless = () => `${ROOT_API}/nuxt/alumni/bless`;

export const getAgreementCheck = ({ courseId }) =>
  `${ROOT_API}/nuxt/student/agreement/check/${courseId}`;
export const makeAgreementSign = ({ courseId }) =>
  `${ROOT_API}/nuxt/student/agreement/sign/${courseId}`;
export const getCourseAgreement = ({ courseId }) =>
  `${ROOT_API}/nuxt/student/course/agreement/${courseId}`;
export const getOrderAgreement = ({ orderId }) =>
  `${ROOT_API}/nuxt/student/order/agreement/${orderId}`;

export const GET_VERSION = `${ROOT_API}/nuxt/public/betaorrelease`;

export const makeAiSearch = () => `${ROOT_API}/nuxt/public/activitysearch`;

export const getWebTreePlan = ({ planId }) => `${ROOT_API}/nuxt/web/tree/plan/${planId}`;

export const DO_AI_SEARCH = `${ROOT_API}/nuxt/ai/search`;
export const GET_AI_HISTORY = `${ROOT_API}/nuxt/ai/history`;
